import api from '@/services/api.service';

const base = 'report';

export default {
    getReportPreTrialNoticesIssued: async (report_category, engineer_rid, period, sum_debt) => {
        try {
            let response = await api.post(`${base}/getReportPreTrialNoticesIssued`, {
                report_category,
                engineer_rid,
                period,
                sum_debt
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getReportCreatedActs: async (report_category, engineer_rid, period, action_type_rid, action_reason_rid) => {
        try {
            let response = await api.post(`${base}/getReportCreatedActs`, {
                report_category,
                engineer_rid,
                period,
                action_type_rid,
                action_reason_rid
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};
